import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-teal-900 text-teal-100 py-12 text-center" data-id="element-30">
        <div className="max-w-4xl mx-auto px-6" data-id="element-31">
          <p className="text-sm opacity-80 mb-4" data-id="element-32">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de ejercicios.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-33">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-teal-200 underline underline-offset-2 hover:text-white transition-colors" data-id="element-34">
              Política de Privacidad
            </button>
            <span className="text-teal-600" data-id="element-35">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-teal-200 underline underline-offset-2 hover:text-white transition-colors" data-id="element-36">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm opacity-60" data-id="element-37">
            &copy; {new Date().getFullYear()} Duerma Sin Dolor. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-38">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-39">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-40">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 sticky top-0 bg-white z-10" data-id="element-41">
                <h3 className="text-xl font-serif font-bold text-teal-900" data-id="element-42">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" data-id="element-43">
                  <XIcon className="w-5 h-5 text-gray-600" data-id="element-44" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-45">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-46" /> : <TermsContent data-id="element-47" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-48">Última actualización: abril 2026</p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-49">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-50">
        Al adquirir nuestra guía digital, recopilamos únicamente la información
        necesaria para procesar tu compra y entregarte el producto: tu dirección
        de correo electrónico y los datos de pago procesados de forma segura por
        nuestra pasarela de pagos externa.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-51">
        2. Uso de la Información
      </h4>
      <p data-id="element-52">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-53">
        <li data-id="element-54">Enviar el producto digital adquirido a tu correo electrónico.</li>
        <li data-id="element-55">Comunicarte actualizaciones importantes sobre tu compra.</li>
        <li data-id="element-56">
          Enviarte contenido relacionado con tu bienestar, del cual puedes darte
          de baja en cualquier momento.
        </li>
      </ul>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-57">
        3. Protección de Datos
      </h4>
      <p data-id="element-58">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines comerciales. Utilizamos medidas de seguridad estándar
        de la industria para proteger tus datos.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-59">4. Cookies</h4>
      <p data-id="element-60">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes desactivar las
        cookies en la configuración de tu navegador.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-61">
        5. Tus Derechos
      </h4>
      <p data-id="element-62">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento. También puedes darte de baja de
        nuestras comunicaciones utilizando el enlace incluido en cada correo
        electrónico.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-63">
        6. Cambios en esta Política
      </h4>
      <p data-id="element-64">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio será publicado en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-65">Última actualización: abril 2026</p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-66">
        1. Producto Digital
      </h4>
      <p data-id="element-67">
        "Duerma Sin Dolor" es una guía digital en formato PDF con contenido
        educativo e informativo sobre el manejo del dolor del nervio ciático.
        Este producto no constituye consejo médico profesional, diagnóstico ni
        tratamiento.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-68">
        2. Descargo de Responsabilidad Médica
      </h4>
      <p data-id="element-69">
        El contenido de esta guía es únicamente informativo y educativo. Siempre
        consulta con un profesional de la salud calificado antes de iniciar
        cualquier programa de ejercicios o cambiar tu rutina de cuidado. Los
        resultados pueden variar de persona a persona.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-70">
        3. Pago y Acceso
      </h4>
      <p data-id="element-71">
        El producto se adquiere mediante un pago único. Una vez procesado el
        pago, recibirás acceso inmediato al material digital en tu correo
        electrónico. El acceso es de por vida y no requiere pagos adicionales.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-72">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-73">
        Todo el contenido de esta guía, incluyendo textos, imágenes y diseños,
        está protegido por derechos de autor. Queda prohibida la reproducción,
        distribución o reventa del material sin autorización expresa.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-74">
        5. Política de Reembolso
      </h4>
      <p data-id="element-75">
        Debido a la naturaleza digital del producto y su entrega inmediata, no
        se ofrecen reembolsos una vez que el producto ha sido entregado. Si
        tienes problemas para acceder al material, nos comprometemos a resolver
        cualquier inconveniente técnico.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-76">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-77">
        No nos hacemos responsables de lesiones, daños o perjuicios que puedan
        resultar del uso o mal uso de la información contenida en esta guía. El
        usuario asume toda la responsabilidad al seguir las recomendaciones del
        material.
      </p>

      <h4 className="font-bold text-teal-900 text-base mt-4" data-id="element-78">
        7. Modificaciones
      </h4>
      <p data-id="element-79">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Los cambios entrarán en vigor desde su publicación en
        esta página.
      </p>
    </>;
}